export const name = 'info';

export const Info = () => (
  <svg
    viewBox="0 0 16 16"
    color="#161616"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
      fill="currentColor"
    />
    <path
      d="M7.96688 4.52441H9.07388L8.85788 5.56841H7.75088L7.96688 4.52441ZM7.58888 6.35141H8.68688L7.69688 10.9999H6.59888L7.58888 6.35141Z"
      fill="white"
    />
  </svg>
);
